<template>
    <div class="zhuce">
        <main>
            <div class="list">
                <h2>注册</h2>
                <van-cell-group inset>
                    
                    <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="zhuchang"
                        label="猪场"
                        placeholder="点击选择"
                        @click="showPicker1 = true"
                    />

                    <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="type"
                        label="运载类别"
                        placeholder="点击选择"
                        @click="showPicker2 = true"
                    />
                     
                    <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="danwei"
                        label="运载单位"
                        placeholder="点击选择"
                        @click="showPicker3 = true"
                    />

                    <van-field v-model="chepai" label="车牌" placeholder="请输入车牌" />
                    <van-field v-model="number" type="number" label="定额装载量" placeholder="请输入定额装载量" />

                    <van-field v-model="tel" type="tel" label="登录手机" placeholder="请输入手机" />
                    <van-field v-model="name" label="姓名" placeholder="请输入姓名" />
                    <van-field v-model="password1" label="登录密码" placeholder="六位以上" />
                    <van-field v-model="password2" label="确认密码" placeholder="六位以上" />

                </van-cell-group>

                <van-popup v-model:show="showPicker1" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns1"
                        @confirm="onConfirm1"
                        @cancel="showPicker1 = false"
                    />
                    </van-popup>

                <van-popup v-model:show="showPicker2" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns2"
                        @confirm="onConfirm2"
                        @cancel="showPicker2 = false"
                    />
                </van-popup>

                <van-popup v-model:show="showPicker3" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns3"
                        @confirm="onConfirm3"
                        @cancel="showPicker3 = false"
                    />
                </van-popup>

                <footer>
                    <van-button type="danger" style="width:100%" @click="sub()" :disabled=disabled>确定</van-button>
                </footer>
            </div>
        </main>

    </div>
</template>

<script>
import { url2  } from '../router/api';
import option from "../config/option.js"

export default {
    data() {
        return {
            zhuchang:'',
            danwei:'',
            name:'',
            chepai:'',
            tel:'',
            number:'',
            type:'',
            columns1:[],
            columns2:[   
                '污水',
                '污泥', 
            ],
            columns3:[],
            showPicker1: false,
            showPicker2: false,
            showPicker3: false,
            password1:'',
            password2:'',
            disabled:true,
        }
    },

    watch: {
        formWatch(val) {
           if(val[5].length == 11 && val[0] && val[1] && val[2] && val[3] && val[4] && val[6] && val[7] && val[8] && val[7].length > 5 && val[7] == val[8]) {
                this.disabled = false
            } else {
                this.disabled = true
            }
        }
    },
    computed: {
        formWatch() {
            let arr = []
            arr.push(this.zhuchang)
            arr.push(this.type)
            arr.push(this.danwei)
            arr.push(this.chepai)
            arr.push(this.number)
            arr.push(this.tel)
            arr.push(this.name)
            arr.push(this.password1)
            arr.push(this.password2)
            return arr
        },
    },
    
    mounted() {
        const elementToRemove = '全部';
        this.columns1 = option.zhuchang.filter(item => item !== elementToRemove);
        this.columns3 = option.danwei;
    },
    methods: {
        onConfirm1(value) {
            this.zhuchang = value;
            this.showPicker1 = false;
        },
        onConfirm2(value) {
            this.type = value;
            this.showPicker2 = false;
        },
        onConfirm3(value) {
            this.danwei = value;
            this.showPicker3 = false;
        },
        sub() {
            this.axios.get(url2+'zhuCe', {
                    params:{
                        zhuchang:this.zhuchang,
                        type: this.type,
                        danwei: this.danwei,
                        chepai: this.chepai,
                        number: this.number,
                        tel: this.tel,
                        name: this.name,
                        password: this.password1
                    }
                }).then(res=> {
                    if(res.data.code==1) {
                        this.$dialog.alert({
                            title: '提示',
                            message: '注册成功',
                        }).then(() => {
                            this.$router.push('./shen')
                        });
                    } else {
                        this.$toast.fail({
                            message: res.data.msg,
                        })
                    }
                }).catch(err=> {
                    console.log(err);
                });
        },
    }
};
</script>
<style lang="less" scoped>
    .zhuce main {
        font-size: 14px;
        padding: 40px 16px 50vh 16px;
        background-color: #FFDCA3;
    }
    .zhuce .list {
        background-color: #fff;
        padding: 20px;
        color: #EE0A24;
    }
    .zhuce h2 {
        text-align: center;
        margin-bottom: 20px;
    }

    .zhuce /deep/ .van-field__label {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        flex: none;
        box-sizing: border-box;
        width: 6.2em;
        margin-right: 30px;
        color: #646566;
        text-align: left;
        word-wrap: break-word;
    }
  
    .zhuce /deep/ .van-uploader {
        position: relative;
        display: inline-block;
        margin-left: 16px;
    }

    .zhuce footer {
        margin-top: 20px;
        padding: 0 20px;
    }

</style>
